import React from "react";
import logo from "./logo3.svg";
import "./App.css";

const App: React.FC = () => {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>Updating... Back within 15-60 minutes.</p>
      </header>
    </div>
  );
};

export default App;
